import React from "react";
import Login from "../pages/auth/login";
import { Navigate, useRoutes } from 'react-router-dom';

const AuthRouter = ({ updatedUser }) => {
    const routes = useRoutes([
        { path: '/login', element: <Login updateUser={updatedUser} /> },
        { path: '*', element: <Navigate to="/login" replace /> }
    ]);

    return <>{routes}</>;
};

export default AuthRouter;